import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import {
  Account,
  Group,
  Project,
  User,
} from '@internal/backstage-plugin-catalog-devops-common';
import {
  DefaultApiClient,
  DefaultApiResponse,
} from '@internal/backstage-plugin-devops-react';
import { AdminApi } from './AdminApi';

export class AdminApiClient extends DefaultApiClient implements AdminApi {
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'catalog',
      ...options,
    });
  }

  async createGroupEntity(data: Group): Promise<DefaultApiResponse> {
    const urlSegment = '/v2/group';
    return await this.post<Group>(urlSegment, data);
  }

  async editGroupEntity(id: string, data: Group): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/group/${id}`;
    return await this.put<Group>(urlSegment, data);
  }

  async deleteGroupEntity(id: string): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/group/${id}`;
    return await this.delete(urlSegment);
  }

  async createUserEntity(data: User): Promise<DefaultApiResponse> {
    const urlSegment = '/v2/user';
    return await this.post<User>(urlSegment, data);
  }

  async editUserEntity(id: string, data: User): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/user/${id}`;
    return await this.put<User>(urlSegment, data);
  }

  async deleteUserEntity(id: string): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/user/${id}`;
    return await this.delete(urlSegment);
  }

  async createAccountEntity(data: Account): Promise<DefaultApiResponse> {
    const urlSegment = '/v2/account';
    return await this.post<Account>(urlSegment, data);
  }

  async editAccountEntity(
    id: string,
    data: Account,
  ): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/account/${id}`;
    return await this.put<Account>(urlSegment, data);
  }

  async deleteAccountEntity(id: string): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/account/${id}`;
    return await this.delete(urlSegment);
  }

  async createProjectEntity(data: Project): Promise<DefaultApiResponse> {
    const urlSegment = '/v2/project';
    return await this.post<Project>(urlSegment, data);
  }

  async editProjectEntity(
    id: string,
    data: Project,
  ): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/project/${id}`;
    return await this.put<Project>(urlSegment, data);
  }

  async deleteProjectEntity(id: string): Promise<DefaultApiResponse> {
    const urlSegment = `/v2/project/${id}`;
    return await this.delete(urlSegment);
  }
}
